const danhSachHoSoDuKien = (state) => state.danhSachHoSoDuKien;
const danhSachHoSo = (state) => state.danhSachHoSo;
const danhSachHoSoDangThucHien = (state) => state.danhSachHoSoDangThucHien;
const themHoSoDuKien = (state) => state.themHoSoDuKien;
const danhSachHienThiCotHoSoCapNhat = (state) =>
  state.danhSachHienThiCotHoSoCapNhat;
const danhSachHienThiCotHoSo = (state) => state.danhSachHienThiCotHoSo;
const danhSachYKien = (state) => state.danhSachYKien;
const danhSachDonViNopDanhMucHoSo = (state) => state.danhSachDonViNopDanhMucHoSo;
const danhSachLichSu = (state) => state.danhSachLichSu;
const hoSoDeMuc = (state) => state.hoSoDeMuc;
const themHoSo = (state) => state.themHoSo;
const danhSachLinhVuc = (state) => state.danhSachLinhVuc;
const danhSachNguoiLapHoSo = (state) => state.danhSachNguoiLapHoSo;

export default {
  themHoSo,
  danhSachHoSo,
  danhSachHoSoDangThucHien,
  danhSachDonViNopDanhMucHoSo,
  danhSachHoSoDuKien,
  themHoSoDuKien,
  danhSachHienThiCotHoSoCapNhat,
  danhSachHienThiCotHoSo,
  danhSachYKien,
  danhSachLichSu,
  hoSoDeMuc,
  danhSachLinhVuc,
  danhSachNguoiLapHoSo,
};
